





import VueOptions from '@utils/VueOptions'

settings =
  name: 'DashboardView'

  vue:
    data: ->
      scriptsHaveBeenLoaded: false

    computed:
      scripts: ->
        [
          'https://cdn.jsdelivr.net/npm/chart.js@4',
          'https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2',
          'https://cdn.jsdelivr.net/npm/chartjs-plugin-doughnutlabel-rebourne@3.0.0-beta.4/dist/chartjs-plugin-doughnutlabel-rebourne.min.js',
        ]

    mounted: ->
      @loadScripts()
      @onScriptsLoaded()

    methods:
      loadScripts: ->
        for src in @scripts
          await @loadScript(src)
        @onScriptsLoaded()

      loadScript: (src) ->
        new Promise((resolve, reject) =>
          index = @scripts.indexOf(src)
          id = "chart-script-#{index}"
          return resolve() if document.getElementById(id)
          script = document.createElement('script')
          script.id = id
          script.src = src
          script.onload = () => resolve()
          script.onerror = () => reject("Failed to load script: #{src}")
          document.head.appendChild(script)
        )

      onScriptsLoaded: ->
        try
          requiredGlobalVariables = [
            Chart
            ChartDataLabels
            DoughnutLabel
          ]

          @scriptsHaveBeenLoaded = requiredGlobalVariables.every((item) => typeof item isnt undefined)
        catch error

export default VueOptions.vue settings
